<template>
  <div class="wrapper">
    <!-- 标题区域 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-document title-icon"></i>
          {{ $route.meta.name }}
        </h2>
      </div>
    </div>
    
    <!-- 内容区域 -->
    <el-card class="content-card" shadow="never">
      <div class="protocol-content">
        <div class="left-menu">
          <div class="menu-title">
            <i class="el-icon-menu"></i>
            <span>协议分类</span>
          </div>
          <el-tabs v-model="activeName" tab-position="left" class="protocol-tabs">
            <el-tab-pane 
              v-for="item in list" 
              :key="item.docKey" 
              :label="item.docKeyName" 
              :name="item.docKey"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <div class="divider-line"></div>
        <div class="right-editor">
          <div class="editor-header">
            <div class="editor-title">
              <i class="el-icon-edit-outline"></i>
              <span>{{ title || '请选择协议类型' }}</span>
            </div>
          </div>
          <div class="editor-wrapper">
            <Editor ref="editor" :content.sync="content"></Editor>
          </div>
          <div class="editor-footer">
            <el-button 
              v-checkbtn="isShowBtn(AUTH_BTN.oprt_protocol_submit)" 
              type="primary" 
              size="small" 
              @click="save"
              class="save-btn"
            >
              保存
            </el-button>
            <el-button 
              type="info" 
              size="small" 
              @click="cancel"
              class="cancel-btn"
            >
              取消
            </el-button>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { authBtnMixin } from '@/mixins/authBtnMixin';
import { getListAPI, getDetailAPI, handleEditAPI } from './api';
import * as mammoth from 'mammoth';
import Editor from '@/components/editor/index.vue';

export default {
  name: 'OprtProtocolList',
  mixins: [authBtnMixin],
  components: { Editor },
  data() {
    return {
      activeName: '',
      content: '',
      list: []
    }
  },
  computed: {
    title() {
      return this.list.find(item => item.docKey == this.activeName)?.docKeyName || '';
    }
  },
  watch: {
    activeName: {
      handler(newV, oldV) {
        if (newV != 0) {
          this.getDetail();
        }
      }
    }
  },
  mounted() {
    this.getList();
    this.$nextTick(() => {
      getListAPI().then(res => {
        this.activeName = res[0]?.['docKey'] || '';
      })
    })
  },

  methods: {
    // 分类
    async getList() {
      this.list = await getListAPI();
    },
    // 详情
    async getDetail() {
      const res = await getDetailAPI(this.activeName);
      this.content = res.content;
      this.$refs.editor.init();
    },
    save() {
      let data = { docKey: this.activeName, content: this.content };
      handleEditAPI(data).then(() => {
        this.$message.success('保存成功');
        this.getDetail();
      })
    },
    cancel() {
      this.getDetail();
      // 初始化编辑器
      this.$refs.editor.init();
    },
    handlerArtSuccess(file) {
      let reader = new FileReader();
      reader.readAsArrayBuffer(file.raw);
      reader.onload = e => {
        const data = e.target.result
        mammoth.convertToHtml({ arrayBuffer: data }).then(res => {
          this.displayResult(res.value);
        })
      }
    },
    displayResult(html) {
      this.content = html
        .replace('<h1>', '<h1 style="text-align:center;">')
        .replace('<h2>', '<h2 style="text-align:center;">')
        .replace('<img', '<img style="width:20%;"')
        .replace(/<table>/g, '<table style="border-collapse:collapse;">')
        .replace(/<tr>/g, '<tr style="height:30px;">')
        .replace(/<td>/g, '<td style="border:1px solid #ccc">')
        .replace(/<p>/g, '<p style="text-indent:2em;">')
      this.$refs.editor.init();
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 28px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
}

// 内容卡片样式
.content-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px;
  }
}

.protocol-content {
  display: flex;
  gap: 20px;
  min-height: 600px;
  
  .left-menu {
    width: 200px;
    flex-shrink: 0;
    
    .menu-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 2px solid #f0f2f5;
      
      i {
        font-size: 18px;
        margin-right: 8px;
      }
    }
    
    .protocol-tabs {
      ::v-deep .el-tabs__header {
        margin: 0;
        
        .el-tabs__nav-wrap.is-left {
          &::after {
            display: none;
          }
        }
        
        .el-tabs__nav {
          .el-tabs__item {
            position: relative !important;
            padding: 12px 16px !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            color: #606266 !important;
            border-radius: 8px !important;
            margin-bottom: 8px !important;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
            border: 1.5px solid transparent !important;
            text-align: left !important;
            background: transparent !important;
            height: auto !important;
            line-height: 1.5 !important;
            
            &:hover {
              color: #409EFF !important;
              background: rgba(64, 158, 255, 0.08) !important;
              border-color: rgba(64, 158, 255, 0.2) !important;
            }
          }
          
          .el-tabs__item.is-active {
            color: #409EFF !important;
            font-weight: 600 !important;
            background: linear-gradient(90deg, rgba(64, 158, 255, 0.15) 0%, rgba(102, 177, 255, 0.08) 100%) !important;
            border-color: #409EFF !important;
            
            &::before {
              content: '' !important;
              position: absolute !important;
              left: 0 !important;
              top: 50% !important;
              transform: translateY(-50%) !important;
              width: 3px !important;
              height: 70% !important;
              min-height: 20px !important;
              background: linear-gradient(180deg, #409EFF 0%, #66b1ff 100%) !important;
              border-radius: 0 2px 2px 0 !important;
              z-index: 10 !important;
            }
          }
        }
      }
      
      ::v-deep .el-tabs__active-bar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }
    }
  }
  
  .divider-line {
    width: 1px;
    background: linear-gradient(180deg, transparent 0%, #e4e7ed 20%, #e4e7ed 80%, transparent 100%);
    flex-shrink: 0;
  }
  
  .right-editor {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    
    .editor-header {
      margin-bottom: 20px;
      padding-bottom: 16px;
      border-bottom: 2px solid #f0f2f5;
      
      .editor-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 18px;
        font-weight: 600;
        color: #303133;
        
        i {
          font-size: 20px;
          margin-right: 8px;
        }
        
        span {
          color: #606266;
        }
      }
    }
    
    .editor-wrapper {
      flex: 1;
      min-height: 500px;
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #E4E7ED;
      background: #ffffff;
      
      ::v-deep .editor-container {
        border-radius: 12px;
      }
    }
    
    .editor-footer {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 2px solid #f0f2f5;
      
      .save-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
        border: none;
        box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover:not(.is-disabled) {
          background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
          box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }
        
        &.is-disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }

      .cancel-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
        border: none;
        box-shadow: 0 4px 12px rgba(144, 147, 153, 0.25);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #909399 0%, #82848a 100%);
          box-shadow: 0 6px 16px rgba(144, 147, 153, 0.35);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .protocol-content {
    flex-direction: column;
    
    .left-menu {
      width: 100%;
      
      .protocol-tabs {
        ::v-deep .el-tabs__header {
          .el-tabs__nav {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            
            .el-tabs__item {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    
    .divider-line {
      width: 100%;
      height: 1px;
      margin: 20px 0;
    }
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .content-card {
    border-radius: 12px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }
  
  .protocol-content {
    gap: 16px;
    
    .right-editor {
      .editor-header {
        .editor-title {
          font-size: 16px;
        }
      }
      
      .editor-wrapper {
        min-height: 400px;
      }
    }
  }
}
</style>
